import { Card } from '@radix-ui/themes'
import { Link } from '@remix-run/react'
import { toCapitalizeFirst } from '#app/utils/textHelpers.ts'

// import { toCapitalizeFirst } from '#app/utils/textHelpers.ts'
type Props = {
	names?: string
	count?: number
}
export default function MostRun(props: Props) {
	const runners = props.names?.split(',').map(name => {
		const [fullName, id] = name.split('-')
		return { fullName: toCapitalizeFirst(fullName), id }
	})

	const Runners = (
		<span>
			{runners?.map(({ fullName, id }, i, arr) => (
				<span key={fullName}>
					<Link
						key={fullName}
						to={`/athlete/${id}`}
						className="text-lg font-bold text-pink-400 underline"
					>
						{fullName}
					</Link>
					{i === arr.length - 1 ? '' : ','}&nbsp;
				</span>
			))}
		</span>
	)

	const runnerCount = runners ? runners.length : 0
	return (
		<Card className="w-full">
			<div className="text-h5">Most Marathons Run This Year</div>
			<div>
				<div>
					{Runners}
					{runnerCount ? (
						<>
							{runnerCount > 1 ? 'have' : 'has'} run the most marathons this year so far at{' '}
							<span className="text-xl text-yellow-500">{props.count}</span>!
						</>
					) : (
						<div />
					)}
				</div>
			</div>
		</Card>
	)
}
